import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { InstructionsRuleProps } from '../../interfaces/components';

const InstructionRule = ({ image, text, heading, isStamp }: InstructionsRuleProps) => {
  return (
    <Box
      display="flex"
      gap="5"
      alignItems="center"
      justifyContent="center"
      w={['290px', '290px', '310px', '350px', '350px']}
      // minH={['80px', '80px', '90px']}
      h="max-content"
      border="1px solid lightgrey"
      px="5"
      py={isStamp ? ['16px', '16px', '16px', '12px'] : ['5px', '5px', '8px', '2px']}
    >
      <Box display="flex">
        <Image
          src={image}
          alt="icon"
          width={isStamp ? ['60px', '60px', '70px', '100px'] : ['90px', '90px', '100px', '130px']}
          height={isStamp ? ['40px', '40px', '50px', '65px'] : ['70px', '70px', '70px', '85px']}
          objectFit="contain"
        />
      </Box>

      <Box display="flex" flexDirection="column" gap="5px">
        {heading && (
          <Text
            textAlign="left"
            fontSize={['12px', '12px', '14px', '14px', '14px']}
            width="auto"
            fontFamily="SangBleuBPLight"
            className="copy"
            fontWeight="700"
          >
            {heading}
          </Text>
        )}
        <Text
          textAlign="left"
          fontSize={['12px', '12px', '14px', '14px', '14px']}
          width="auto"
          fontFamily="SangBleuBPLight"
          className="copy"
          fontWeight="500"
        >
          {text}
        </Text>
      </Box>
    </Box>
  );
};

export default InstructionRule;
